// src/pwa.ts
import { useRegisterSW } from 'virtual:pwa-register/react';

export const usePWA = () =>
  useRegisterSW({
    onNeedRefresh() {
      console.log('🔄 New content available');
    },
    onOfflineReady() {
      console.log('✅ App ready for offline use');
    },
  });
